import { useState, useCallback, useMemo ,useEffect} from 'react';
import { useRequest } from 'ahooks';
import { getSavedContent } from '../../../axios/api'

function useGetSavedContent(){
  
    const { loading:savedContentLoading, data:savedContentData, runAsync:getSavedContentAction } = useRequest(
        async (fold_id) => {
          try {
            const resp =  await getSavedContent({'fold_id':fold_id}) 
            return resp?.data ?? [];
          } catch (error) {
            console.log(error)
            return [];
          }
        },
        {
            debounceWait: 240,
            manual: true,
          },      
    );

    return {
        savedContentLoading, 
        savedContentData, 
        getSavedContentAction    
    }
}
    
export default useGetSavedContent